/*
 * Vídeo com texto (sections/video-with-text.liquid): o vídeo arranca sem som quando entra no ecrã
 * e pára quando sai. Um <video> mudo pode ser reproduzido sem gesto do visitante; com som não, e é
 * por isso que o som se liga nos controlos nativos. Quem carrega em pausa fica em pausa: só se
 * volta a arrancar o que nós próprios parámos ao sair do ecrã. Com prefers-reduced-motion nada
 * arranca sozinho; ficam os controlos.
 */
(function () {
  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Reproduz; se o navegador recusar (só acontece com som ligado), volta a mudo e tenta de novo.
  function play(video) {
    var p = video.play();
    if (p && p.catch) {
      p.catch(function () {
        if (!video.muted) {
          video.muted = true;
          var p2 = video.play();
          if (p2 && p2.catch) p2.catch(function () {});
        }
      });
    }
  }

  function init(video) {
    if (video.dataset.vtReady || REDUCED) return;
    video.dataset.vtReady = '1';
    video.muted = true; // o atributo só conta no primeiro carregamento; daí em diante manda a propriedade

    var pausedByUs = false;
    var pausedByUser = false;
    video.addEventListener('pause', function () {
      if (!pausedByUs && !video.ended) pausedByUser = true;
      pausedByUs = false;
    });
    video.addEventListener('play', function () {
      pausedByUser = false;
    });

    if (!('IntersectionObserver' in window)) {
      play(video);
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            if (!pausedByUser) play(video);
          } else if (!video.paused) {
            pausedByUs = true;
            video.pause();
          }
        });
      },
      { threshold: 0.5 }
    );
    io.observe(video);
  }

  function boot(scope) {
    scope.querySelectorAll('.video-with-text video').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  // Volta a ligar quando o editor de temas re-renderiza a secção.
  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();
